/** @jsxImportSource theme-ui */
import { Box, Container, Title, View } from "@bottlebooks/gatsby-design-system";

export default function Section({ variant = "light", children, ...rest }) {
  return (
    <Box
      sx={{
        paddingY: 4,
        backgroundColor:
          variant === "accent"
            ? "accent"
            : variant === "grey"
            ? "light"
            : "transparent",
      }}
      {...rest}
      className={`bb-section bb-section-${variant}`}
    >
      <Container fluid sx={{ maxWidth: "container.fluid" }}>
        {children}
      </Container>
    </Box>
  );
}

Section.Wrapper = function ({ children }) {
  return children;
};

Section.Title = function ({ children, ...rest }) {
  return (
    <Title sx={{ marginBottom: 3 }} {...rest}>
      {children}
    </Title>
  );
};

Section.Body = function ({ children, ...rest }) {
  return <Box {...rest}>{children}</Box>;
};
